import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {map, Observable, switchMap} from "rxjs";
import {RecordData, RecordsDataRequestQueryParams} from "../../../../types/records-table.types";
import {baseUrl} from "../../../../constants/base-url";
import {BaseModalApiService} from "../../services/base-modal-api.service";
import {contactResourceType} from "../configs/contacts-modal-config";
import {CreateContactDataParams} from "../types/contacts-modal.types";

@Injectable({
  providedIn: 'root'
})
export class ContactsModalApiService {
  private http: HttpClient = inject(HttpClient);
  private baseModalApiService: BaseModalApiService = inject(BaseModalApiService);

  private contactsUrl = `${baseUrl}/${contactResourceType.path}`;

  public fetchContactsData(queryParams: RecordsDataRequestQueryParams): Observable<Array<RecordData>> {
    return this.http.get<Array<RecordData>>(`${this.contactsUrl}/`, {params: queryParams});
  }

  public createContactData({ recordData, recordCalendarId }: CreateContactDataParams): Observable<RecordData> {
    return this.http.post<RecordData>(`${this.contactsUrl}`, recordData).pipe(
      switchMap((createData: RecordData) => {
        return this.baseModalApiService.attachRecordData({
          recordCalendarId: recordCalendarId,
          id: Number(createData.id),
          path: contactResourceType.path
        }).pipe(
          map(() => createData)
        );
      })
    );
  }
}
